import React from 'react'
import styled, { css } from 'styled-components'
import Close from '@icons/modalClose.inline.svg'
import Box from '@components/Box'
import { above } from '@styles/mixins/breakpoints'

const SModalWrap = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 105;
  padding: 0 8px;
`

const SOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #0b0b0b;
  opacity: 0.8;
`

const SModal = styled.div`
  max-width: 900px;
  width: 100%;
  box-shadow: ${({ theme }) => theme.general.boxShadow};
  position: relative;
  z-index: 1;
`

const SClose = styled(Box)`
  position: absolute;
  cursor: pointer;
  font-size: 28px;
  line-height: 44px;
  color: #fff;
  text-align: end;
  top: -40px;
  right: 0;
  font-family: Arial, Baskerville, monospace;
`

const VideoWrapper = styled(Box)`
  position: relative;
  width: 100%;
  padding-top: 56.25%;
`

const Video = styled.iframe`
  object-fit: contain;
  object-position: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export interface IModal {
  isOpen: boolean
  onClose: () => void
  children?: JSX.Element | boolean
  linkVideo?: string
}

const hostVariant = {
  youTube: 'www.youtube.com',
  rutube: 'rutube.ru',
}

const generateSrcToIframe = (link: string): string => {
  const url = link.slice(-1) === '/' ? link.slice(0, -1) : link
  const parser = new URL(url)

  const params = {
    host: '',
    path: '',
  }

  switch (parser.hostname) {
    case hostVariant.youTube: {
      params.host = hostVariant.youTube
      params.path = parser.search.split('=')[1]
      break
    }
    case hostVariant.rutube: {
      params.host = hostVariant.rutube
      params.path = parser.pathname.split('/')[2]
      break
    }
  }

  const src = `${parser.origin}/${params.host === hostVariant.rutube ? 'play/embed' : 'embed'}/${params.path}`
  return src
}

const Modal: React.FC<IModal> = ({ isOpen, onClose, children, linkVideo }) => {
  return isOpen ? (
    <SModalWrap>
      <SOverlay onClick={onClose} />
      <SModal>
        <SClose onClick={onClose}>×</SClose>
        {children ||
          (linkVideo && (
            <VideoWrapper>
              <Video
                width="100%"
                height="550"
                src={generateSrcToIframe(linkVideo)}
                title="Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></Video>
            </VideoWrapper>
          ))}
      </SModal>
    </SModalWrap>
  ) : (
    <></>
  )
}

export default Modal
